import { Link } from "react-router-dom"
import { SidebarMenuItem, SidebarMenuButton, useSidebar } from "@/components/ui/sidebar"

export function NavItem({ to, icon, children }: { to: string; icon: React.ReactNode; children: React.ReactNode }) {
  const { setOpenMobile } = useSidebar()

  return (
    <SidebarMenuItem>
      <SidebarMenuButton asChild onClick={() => setOpenMobile(false)}>
        <Link to={to} className="flex gap-2">
          {icon}
          <span>{children}</span>
        </Link>
      </SidebarMenuButton>
    </SidebarMenuItem>
  )
}
